export default '1.11.7';



// WEBPACK FOOTER //
// ./src/lib/version.js